import { KENO_SNAKES_AUDIO_KEYS, KENO_SNAKES_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/keno-snakes/`

  if (!scene.textures.getTextureKeys().includes(KENO_SNAKES_TEXTURE_KEYS.ATLAS)) {
    scene.load.atlas(
      KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      `${prefix}animation-keno-snakes-images-0.png`,
      `${prefix}animation-keno-snakes-images.json`,
    )
  }

  for( const value of Object.values(KENO_SNAKES_AUDIO_KEYS) ) {
      
      if(!scene.cache.audio.exists(value)) {
        scene.load.audio(value, `sounds/${value}`)
      }
    }
}
